<div style=" border-color: rgb(51, 50, 50);border-style:double;" class="container-fluid"><br>
  <div class="d-flex justify-content-between align-items-center">
    <h4 *ngIf="fitreTache === 'arealiser'">Tâches à réaliser ({{tacheData.length}})
    </h4>
    <h4 *ngIf="fitreTache === 'realise'">Tâches Réalisées ({{tacheData.length}})</h4>
    <h4 *ngIf="fitreTache === 'retard'">Tâches En retard ({{tacheData.length}}) </h4>
    <button type="button" class="btn-close" (click)="close()"></button>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div>
        <div>
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light  rwd-table">
                <tr>
                  <!-- <button  (click)="Modal()"
                  title="Cliquez ici pour voir les réalisation" class="btn btn-success btn-sm">
                  <i class="mdi mdi-forward me-2"></i>Réalisation
                </button> -->
                  <th>Code</th>
                  <th>Libellé</th>
                  <th>Date de début</th>
                  <th>Date de fin</th>
                  <th>Poids PTA</th>
                  <th>Taux de réalisation</th>
                  <th>Poids réalisé</th>
                  <th style="width: 120px;">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedItems; let index = index">
                  <td>{{item?.code}}</td>
                  <td>{{item?.libelle}}</td>
                  <td>{{item?.date_debut | dateFormat}}</td>
                  <td>{{item?.date_fin | dateFormat}}</td>
                  <td>{{item.poids}}</td>
                  <td>{{item.taux_final}}</td>
                  <td>{{item.poids_realise}}</td>


                  <td>
                    <div class="d-flex flex-nowrap gap-2 align-items-center">

                      <span [title]="!isFirstNonRealised(index) 
    ? 'Veuillez d’abord réaliser les tâches antérieures non réalisées' 
    : 'Cliquez ici pour réaliser cette tâche'">

                        <button style="font-size: 13px; white-space: nowrap;" *ngIf="item.est_realise === false"
                          (click)="detailModal(item)" [disabled]="!isFirstNonRealised(index)" [ngClass]="{
      'btn-secondary': !isFirstNonRealised(index), 
      'btn-success': isFirstNonRealised(index)
    }" class="btn btn-sm">

                          <i class="mdi mdi-forward me-1"></i> Réaliser
                        </button>

                      </span>

                      <button *ngIf="item.pta_detail_realisation_taches.length > 0" style="font-size: 13px; white-space: nowrap;" (click)="detailModalProgressTache(item)"
                        title="Cliquez ici pour voir les détails" class="btn btn-success btn-sm">
                        <i class="mdi mdi-eye me-1"></i> Détails
                      </button>

                      <button *ngIf="fitreTache === 'realise'" (click)="annulerTacheRealiser(item)"
                        title="Cliquez ici pour annuler" class="btn btn-secondary btn-sm" style="white-space: nowrap;">
                        <i class="pi pi-minus-circle me-1"></i> Annuler
                      </button>

                    </div>
                  </td>

                </tr>
              </tbody>
            </table>

            <div class="d-flex justify-content-center" *ngIf="isLoading === true">
              <div class="container">
                <div class="row">
                  <div class="text-center">
                    <h5 id="graycolor">Chargement en cours...</h5>
                    <div class="loader4"></div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center">
              <div class="container">
                <div class="row">
                  <div class="text-center">
                    <h5 id="graycolor">Aucune donnée trouvée</h5>
                  </div>
                </div>
              </div>

            </div>
            <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
              [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
            </p-paginator>
          </div>
        </div>

      </div>
    </div>

  </div>

</div>
<ng-template #tacheModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{itemTache.libelle}}</h5>
    <button (click)="modal.dismiss('Close click')" type="button" class="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form>
        <div class="d-flex">
          <div class="form-group col-md-4">
            <label for="name">Code</label>
            <input style="background-color: aliceblue; " [(ngModel)]="itemTache.code" name="code" disabled type="text"
              class="form-control" id="code" placeholder="un code" />
          </div>
          &nbsp;
          <div class="form-group col-md-4">
            <label for="name">Libellé</label>
            <input style="background-color: aliceblue;" [(ngModel)]="itemTache.libelle" name="libelle" disabled
              type="text" class="form-control" id="name" placeholder="libellé" />
          </div>
          <div class="form-group col-md-4">
            <label for="email">Poids</label>
            <input style="background-color: aliceblue;" type="number" disabled [(ngModel)]="itemTache.poids"
              name="poids_action" class="form-control" id="email" placeholder="Poids" />
          </div>
        </div>
        <br />

        <div class="d-flex">

          <div class="form-group col-md-4">
            <label>Date d'enregistrement</label>
            <input style="background-color: aliceblue;" disabled [(ngModel)]="itemTache.date_enregistrement"
              name="responsable_action" type="text" class="form-control" />
          </div>
          <div class="form-group col-md-4">
            <label for="email">Date de réalisation</label>
            <input [(ngModel)]="itemTache.date_realisation" name="Date_de_realisation" type="date" class="form-control"
              id="text" placeholder="Date de réalisation" />
          </div>
          &nbsp;
          <div class="form-group col-md-4">
            <label>Preuve de réalisation</label>
            <input (change)="onFileSelected($event)" name="preuve" type="file" class="form-control"
              placeholder="Preuve de réalisation" />
          </div>

        </div>


        <br />

        <!-- Ligne combinée -->
        <div class="d-flex">
          <!-- Case à cocher : Entièrement réalisée -->
          <div class="form-group col-md-4">
            <label>
              <input type="checkbox" [(ngModel)]="itemTache.entierementRealisee" name="entierementRealisee"
                (ngModelChange)="onEntierementRealiseeChange()" />
              Entièrement réalisée
            </label>
          </div>

          <!-- Pourcentage de réalisation -->
          <div class="form-group col-md-4">
            <label>Pourcentage de réalisation ( {{ itemTache.pourcentageRealisation || 0 }} %)</label>
            <!-- <input
              type="number"
              class="form-control"
              [(ngModel)]="itemTache.pourcentageRealisation"
              name="pourcentageRealisation"
              min="0"
              max="100"
              placeholder="0 - 100%"
              (ngModelChange)="onPourcentageChange()"
            /> -->
            <div>
              <input [disabled]="isDisabled===true" type="number" maxlength="100" min="0" max="100"
                (change)="onPourcentageChange()" (keyup)="onPourcentageChange()"
                [(ngModel)]="itemTache.pourcentageRealisation" placeholder="0" name="pourcentageRealisation"
                class="form-control w-full mb-3" />
              <!-- <p-slider [disabled]="isDisabled===true"
              [(ngModel)]="itemTache.pourcentageRealisation"name="pourcentageRealisation"(onChange)="onPourcentageChange()"
              [step]="1"
              [min]="0"
              [max]="100"
              class="w-full"
            ></p-slider> -->

            </div>
          </div>

          <!-- Poids réalisé (désactivé) -->
          <div class="form-group col-md-4 ms-2">
            <label>Poids réalisé (%)</label>
            <input type="number" class="form-control" disabled placeholder="0"
              [value]="itemTache.poidsrelaliseenpourcentage" disabled />
          </div>
        </div>
        <br />

        <!-- Observation seule -->
        <div class="form-group col-md-12">
          <label>Observations</label>
          <textarea [(ngModel)]="itemTache.observation" name="Observations" class="form-control"
            placeholder="Observations" minlength="10" style="height: 50px"></textarea>
        </div>
        <br />

        <!-- Boutons -->
        <div class="text-end">
          <button (click)="modal.dismiss('Close click')" type="button" class="btn btn-light ms-1">
            <i class="pi pi-times" style="color: #212529"></i> Annuler
          </button>
          &nbsp;
          <button *ngIf="fitreTache === 'arealiser' || fitreTache === 'retard'"
            (click)="saveTacheToSousActiviter(modal)" type="submit" class="btn btn-success">
            <i class="pi pi-save" style="color: white"></i> Réaliser
          </button>

          <button *ngIf="fitreTache === 'realise'" (click)="saveTacheToSousActiviter(modal)" type="submit"
            class="btn btn-success">
            <i class="pi pi-save" style="color: white"></i> A réaliser
          </button>
        </div>
      </form>

    </div>
  </div>
</ng-template>


<ng-template #tacheModalProgress let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Details des réalisations de :{{detailsProgItems.libelle}}</h5>
    <button (click)="modal.dismiss('Close click')" type="button" class="btn-close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="col-lg-12">
      <div>
        <div>
          <div class="table-responsive mt-3">
            <h3 class="text-center">Poids PTA : {{this.detailsProgItems.poids}}</h3>
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light  rwd-table">
                <tr>
                  <!-- <button  (click)="Modal()"
                  title="Cliquez ici pour voir les réalisation" class="btn btn-success btn-sm">
                  <i class="mdi mdi-forward me-2"></i>Réalisation
                </button> -->
                  <th>Date enregistrement</th>
                  <th>Date réalisation</th>
                  <th>Taux de réalisation</th>
                  <th>Poids réalisé</th>
                  <th></th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedItemsProgres; let index = index">
                  <td>{{item?.date_enregistrement | dateFormat}}</td>
                  <td>{{item?.date_realisation | dateFormat}}</td>
                  <td>{{item.taux_realisation}}</td>
                  <td>{{item.poids_realise}}</td>
                  <button (click)="annulerTacheRealiserProgres(item)" title="Cliquez ici pour annuler"
                    class="btn btn-secondary btn-sm">
                    <i class="pi pi-minus-circle me-1"></i>Annuler
                  </button>
                </tr>
              </tbody>
            </table>

            <div *ngIf="paginatedItemsProgres.length === 0" class="d-flex justify-content-center">
              <div class="container">
                <div class="row">
                  <div class="text-center">
                    <h5 id="graycolor">Aucune donnée trouvée</h5>
                  </div>
                </div>
              </div>

            </div>
            <p-paginator (onPageChange)="onPageChange($event)" [first]="first1" [rows]="rows1"
              [totalRecords]="totalRecords2" [rowsPerPageOptions]="[10, 20, 30]">
            </p-paginator>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template>
<p-toast />